import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'authentication/services/token.service';
import { EMPTY, catchError } from 'rxjs';
import { IS_SHIJI_USER_KEY } from 'shared/constants/general-constants';
import { StorageService, ToastService, UserApiService } from 'shared/services';

@Component({
    selector: 'app-user-redirect',
    imports: [],
    templateUrl: './user-redirect.component.html',
    styleUrls: ['./user-redirect.component.scss'],
})
export class UserRedirectComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private tokenService: TokenService,
        private userApiService: UserApiService,
        private storageService: StorageService,
        private toastService: ToastService,
        private destroyRef: DestroyRef,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.route.queryParams
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError((error) => {
                    //GraphQL calls
                    const statusCode = error.networkError?.status;
                    //Account disabled
                    if (statusCode === 423) {
                        this.toastService.showToast({
                            body: 'generalKeywords.accountDisabled',
                            severity: 'error',
                            duration: 8000,
                            ignoreRemoval: true,
                        });
                        this.storageService.clearLocal();
                        this.storageService.clearSession();

                        return EMPTY;
                    }

                    throw error;
                }),
            )
            .subscribe((params) => {
                if (params && params.returnToken) {
                    this.tokenService.setToken(params.returnToken);
                    this.storageService.setInLocal(IS_SHIJI_USER_KEY, false);
                    this.userApiService.getCurrentUser();
                }

                this.router.navigate(['/dashboard']);
            });
    }
}
